<template>
<v-layout row wrap>
<!-- <v-flex xs12 sm6 offset-sm3> -->
  <v-flex xs6>
    <v-card class="card--flex-toolbar ma-2" height="95%">
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">충전소 목록</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="$_assign">save</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>
      <v-progress-linear v-show="leftLoading" color="blue" indeterminate height="2" style="margin: 0 auto"/>

      <div style="max-height:70vh;" class="scroll-y">
        <template v-for="place in places">
          <v-card :key="place.id" :dark="place.changed ? true : false">
            <v-card-title>{{place.name}}</v-card-title>
            <v-card-text>
              <draggable v-model="place.chargers" group="chargers" style="min-height:20px;" @change="$_onChange($event, place)">
                <template v-for="charger in place.chargers">
                  <v-chip v-if="charger.moved" :key="charger.id" color="primary" text-color="white">
                    {{charger.managementNumber}}
                  </v-chip>
                  <v-chip v-else :key="charger.id">
                    {{charger.managementNumber}}
                  </v-chip>
                </template>
              </draggable>
            </v-card-text>
          </v-card>
        </template>
      </div>
    </v-card>
  </v-flex>
  <v-flex xs6>
    <v-card class="card--flex-toolbar ma-2" height="95%">
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">충전기 목록</v-toolbar-title>
      </v-toolbar>

      <v-divider></v-divider>
      <v-progress-linear v-show="rightLoading" color="blue" indeterminate height="2" style="margin: 0 auto"/>

      <v-card-text style="max-height:70vh;" class="scroll-y">
        <draggable v-model="chargers" group="chargers" style="min-height:20px" @change="$_onChange($event)">
          <template v-for="charger in chargers">
            <v-chip v-if="charger.moved" :key="charger.id" color="primary" text-color="white">
              {{charger.managementNumber}}
            </v-chip>
            <v-chip v-else :key="charger.id">
              {{charger.managementNumber}}
            </v-chip>
          </template>
        </draggable>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import draggable from 'vuedraggable'

export default {
  name: 'ChargerAssign',
  components: {
    draggable
  },
  data () {
    return {
      places: [],
      chargers: [],
      leftLoading: false,
      rightLoading: false
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getDatas()
    }
  },
  created () {
    this.$emit('title', '구성 (충전소 - 충전기)')
    this.$_getDatas()
  },
  methods: {
    async $_getDatas () {
      this.places = []
      this.chargers = []

      try {
        // let [placesSnapshot, chargersSnapshot] = await Promise.all([this.$fs.collection('places').where('group', '==', this.$store.state.session.group).orderBy('name').get(),
        //  this.$fs.collection('chargers').where('group', '==', this.$store.state.session.group).orderBy('managementNumber').get()])

        this.leftLoading = true
        let placesSnapshot
        if (this.$DEBUG) {
          placesSnapshot = await this.$fs.collection('places').orderBy('name').get()
        } else {
          placesSnapshot = await this.$fs.collection('places').where('group', '==', this.$store.state.session.group).orderBy('name').get()
        }

        this.places = []
        placesSnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data()}`)

          var item = doc.data()
          item.id = doc.id
          item.chargers = []
          this.places.push(item)
        }) // forEach

        this.rightLoading = true
        let chargersSnapshot
        if (this.$DEBUG) {
          chargersSnapshot = await this.$fs.collection('chargers').orderBy('managementNumber').get()
        } else {
          chargersSnapshot = await this.$fs.collection('chargers').where('group', '==', this.$store.state.session.group).orderBy('managementNumber').get()
        }
        this.chargers = []
        chargersSnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data()}`)

          var item = doc.data()
          item.id = doc.id

          // places 에서 ref 가 있는지 확인 후 mapping
          var place = this.places.find(place => {
            if (place.chargerRefs) {
              for (var i = 0; i < place.chargerRefs.length; i++) {
                if (place.chargerRefs[i].id === item.id) {
                  return place
                }
              }
            }
            return null
          })

          if (place) {
            place.chargers.push(item)
          } else {
            this.chargers.push(item)
          }
        })
      } catch (error) {
        this.$emit('snackbar', '충전소-충전기 정보를 가져오지 못하였습니다.')
        console.log(error)
      }

      this.leftLoading = false
      this.rightLoading = false
    },
    $_onChange (evt, place) {
      let charger

      if (evt.added) {
        charger = evt.added.element
      } else if (evt.removed) {
        charger = evt.removed.element
      } else if (evt.moved) {
        // charger = evt.moved.element
        return true
      }

      charger.moved = true

      if (place) {
        place.changed = true
        place.chargers = [...place.chargers] // vue 에서 바로 변형 감지가 안되어 배열 복사하여 UI 바로 업데이트 함.
      }

      return true
    },
    /**
     * 충전소에 충전기 할당
     *
     * 1. 모든 충전기의 기존 충전소 정보 삭제
     * 2. 각 충전기에 신규 충전소 정보 추가
     * 3. 모든 충전소에 충전기들 정보 업데이트
     */
    $_assign () {
      let batch = this.$fs.db().batch() // batch 는 500개가 한계

      // 장소에 이동된 충전기 할당
      this.places.forEach(place => {
        if (place.changed) {
          let placeRef = this.$fs.collection('places').doc(place.id)

          if (place.chargers.length > 0) {
            let newChargerRefs = []
            for (let i = 0; i < place.chargers.length; i++) {
              let newChargerRef = this.$fs.collection('chargers').doc(place.chargers[i].id)

              batch.update(newChargerRef, {'placeRef': placeRef,
                updated: firebase.firestore.FieldValue.serverTimestamp()})

              newChargerRefs.push(newChargerRef) // for 이후 한번에 저장할 장소 정보
            }

            batch.update(placeRef, {'chargerRefs': newChargerRefs,
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          } else {
            batch.update(placeRef, {'chargerRefs': firebase.firestore.FieldValue.delete(),
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          }
        }
      })

      // 이동된 충전기에서 장소 정보 삭제
      this.chargers.forEach(charger => {
        if (charger.moved) {
          let chargerRef = this.$fs.collection('chargers').doc(charger.id)

          batch.update(chargerRef, {'placeRef': firebase.firestore.FieldValue.delete(),
            updated: firebase.firestore.FieldValue.serverTimestamp()})
        }
      })

      /* // 전체 장소 목록을 반복하면서
      this.places.forEach(place => {
        var placeRef = this.$fs.collection('places').doc(place.id)

        if (place.chargerRefs) { // 기존 정보들은 우선 제거
          place.chargerRefs.forEach((chargerRef, index, array) => { // 각각의 charger 에서 place 정보 제거, place 에서 charger 정보 변경은 아래에서
            // TODO 같은 값이면 skip 필요
            batch.update(chargerRef, {'placeRef': firebase.firestore.FieldValue.delete(),
              updated: firebase.firestore.FieldValue.serverTimestamp()})
          })

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        }

        var newChargerRefs = []
        for (var i = 0; i < place.chargers.length; i++) {
          var newChargerRef = this.$fs.collection('chargers').doc(place.chargers[i].id)
          newChargerRefs.push(newChargerRef) // for 이후 한번에 저장할 장소 정보

          // TODO 같은 값이면 skip 필요
          batch.update(newChargerRef, {'placeRef': placeRef,
            updated: firebase.firestore.FieldValue.serverTimestamp()})

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        }

        if (newChargerRefs.length > 0) {
          // TODO 같은 값이면 skip 필요
          batch.update(placeRef, {'chargerRefs': newChargerRefs,
            updated: firebase.firestore.FieldValue.serverTimestamp()})

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        } else {
          batch.update(placeRef, {'chargerRefs': firebase.firestore.FieldValue.delete(),
            updated: firebase.firestore.FieldValue.serverTimestamp()})

          // 로컬의 정보 업데이트 또는 전체 새로 고침, 간단히 새로 고침으로 처리함
        }
      }) */

      // Commit the batch
      batch.commit()
        .then(() => {
          this.$emit('snackbar', '저장 되었습니다.')
          console.log('success')

          this.$_getDatas() // reset
        })
        .catch(error => {
          this.$emit('snackbar', '오류발생으로 저장하지 못하였습니다.')
          console.log('error', error)

          this.$_getDatas() // reset
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Charger/ChargerAssign.vue